import pollsCss from "../../assets/styles/polls/polls.module.scss";

const GifResult = ({ pollResponse }) => {
  const mergedResponses = new Map();

  pollResponse.forEach((item) => {
    if (
      item.poll_option_id &&
      (!item.archived || (item.archived && item.response_count > 0))
    ) {
      if (mergedResponses.has(item.poll_option_id)) {
        mergedResponses.get(item.poll_option_id).response_count +=
          item.response_count || 0;
      } else {
        mergedResponses.set(item.poll_option_id, { ...item });
      }
    }
  });

  const filteredPollResponse = Array.from(mergedResponses.values());

  const labels = filteredPollResponse.map((item) => item.option_text);
  const responseCounts = filteredPollResponse.map((item) =>
    item.total_response ? item.total_response : item.response_count
  );

  // Calculate total responses
  const totalResponses = responseCounts.reduce((sum, count) => sum + count, 0);

  // Calculate percentages and round to nearest 10
  const percentages = responseCounts.map((count) => {
    const percentage = (count / totalResponses) * 100;
    return Math.round(percentage / 10) * 10;
  });


  return (
    <>
      {filteredPollResponse?.length > 0 &&
        filteredPollResponse?.map((item, index) => (
          <div key={index} className={pollsCss.gifResult}>
            <div className={pollsCss.gifResultHeader}>
              <div className={pollsCss.gifResultHeaderImage}>
                <img src={item.gif_url} alt="gif" />
              </div>
              <div className={pollsCss.gifResultHeaderText}>
                <h2>
                  {percentages[index] !== undefined &&
                  !isNaN(percentages[index])
                    ? percentages[index]
                    : 0}
                  % ({item.response_count})
                </h2>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default GifResult;
